import { render, staticRenderFns } from "./faceDetection.vue?vue&type=template&id=597114ca&scoped=true&"
import script from "./faceDetection.js?vue&type=script&lang=js&"
export * from "./faceDetection.js?vue&type=script&lang=js&"
import style0 from "./faceDetection.css?vue&type=style&index=0&id=597114ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597114ca",
  null
  
)

export default component.exports